export const translations = {
  en: {
    nav: {
      home: "Home",
      fleet: "Our Fleet",
      about: "About Us",
      contact: "Contact",
      bookNow: "Book Now",
      admin: "Admin",
    },
    hero: {
      title: "Explore Thessaloniki",
      titleAccent: "Your Way",
      subtitle: "Premium car rental in the heart of Northern Greece. From compact city cars to luxury SUVs.",
      cta: "Browse Fleet",
      ctaSecondary: "Get a Quote",
    },
    booking: {
      pickupDate: "Pick-up Date",
      returnDate: "Return Date",
      pickupLocation: "Pick-up Location",
      category: "Vehicle Type",
      search: "Search Available Cars",
      office: "Office - Pylaea",
      airport: "Thessaloniki Airport (SKG)",
      hotel: "Hotel Delivery",
      allTypes: "All Types",
    },
    fleet: {
      title: "Our Fleet",
      subtitle: "Choose from our diverse range of well-maintained vehicles",
      perDay: "/day",
      viewDetails: "View Details",
      bookThis: "Book This Car",
      filters: "Filters",
      category: "Category",
      fuel: "Fuel Type",
      transmission: "Transmission",
      all: "All",
      economy: "Economy",
      compact: "Compact",
      suv: "SUV",
      family: "Family",
      premium: "Premium",
      luxury: "Luxury",
      gasoline: "Gasoline",
      diesel: "Diesel",
      hybrid: "Hybrid",
      lpg: "LPG",
      manual: "Manual",
      automatic: "Automatic",
      seats: "seats",
      hp: "hp",
      year: "Year",
      mileage: "Mileage",
      engine: "Engine",
      features: "Features",
      noCars: "No cars match your filters",
    },
    about: {
      title: "About Euro Cars",
      subtitle: "Your trusted car rental partner in Thessaloniki since 2020",
      story: "Euro Cars was founded with a simple mission: to provide reliable, affordable, and premium car rental services in Thessaloniki and Northern Greece. Based in Pylaea, we offer a diverse fleet ranging from economical city cars to luxury performance vehicles.",
      mission: "Our Mission",
      missionText: "To deliver an exceptional car rental experience with transparent pricing, well-maintained vehicles, and personalized service that makes every journey memorable.",
      whyUs: "Why Choose Us",
      reasons: [
        "Wide range of well-maintained vehicles",
        "Competitive daily rates starting from \u20AC20",
        "Free delivery to Thessaloniki Airport",
        "24/7 roadside assistance",
        "Flexible pickup & return",
        "No hidden fees",
      ],
    },
    contact: {
      title: "Contact Us",
      subtitle: "We're here to help you find the perfect ride",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        subject: "Subject",
        message: "Your Message",
        send: "Send Message",
        success: "Message sent successfully!",
      },
      info: {
        address: "Tompazi 49, Pilea 555 35, Greece",
        phone: "+30 690 908 6661",
        email: "info@eurocars-rent.gr",
        hours: "Mon-Fri: 09:00-21:00 | Sat-Sun: 09:00-19:00",
      },
    },
    services: {
      title: "Our Services",
      subtitle: "Everything you need for a perfect trip",
      items: [
        { title: "Airport Transfer", desc: "Free delivery & pickup at Thessaloniki Airport (SKG)" },
        { title: "Hotel Delivery", desc: "We bring the car to your hotel anywhere in the city" },
        { title: "24/7 Support", desc: "Round-the-clock roadside assistance and customer service" },
        { title: "Full Insurance", desc: "Comprehensive coverage for worry-free driving" },
      ],
    },
    bookingForm: {
      title: "Complete Your Reservation",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      pickupDate: "Pick-up Date",
      returnDate: "Return Date",
      pickupLocation: "Pick-up Location",
      notes: "Special Requests",
      submit: "Confirm Booking",
      success: "Booking submitted successfully! We'll contact you shortly.",
      total: "Estimated Total",
      days: "days",
    },
    footer: {
      tagline: "Premium car rental in Thessaloniki, Greece",
      quickLinks: "Quick Links",
      contactInfo: "Contact Info",
      hours: "Working Hours",
      rights: "All rights reserved.",
      monFri: "Monday - Friday: 09:00 - 21:00",
      satSun: "Saturday - Sunday: 09:00 - 19:00",
    },
    common: {
      from: "from",
      km: "km",
      cc: "cc",
    },
  },
  el: {
    nav: {
      home: "\u0391\u03c1\u03c7\u03b9\u03ba\u03ae",
      fleet: "\u03a3\u03c4\u03cc\u03bb\u03bf\u03c2",
      about: "\u03a3\u03c7\u03b5\u03c4\u03b9\u03ba\u03ac",
      contact: "\u0395\u03c0\u03b9\u03ba\u03bf\u03b9\u03bd\u03c9\u03bd\u03af\u03b1",
      bookNow: "\u039a\u03c1\u03ac\u03c4\u03b7\u03c3\u03b7",
      admin: "\u0394\u03b9\u03b1\u03c7\u03b5\u03af\u03c1\u03b9\u03c3\u03b7",
    },
    hero: {
      title: "\u0395\u03be\u03b5\u03c1\u03b5\u03c5\u03bd\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b7 \u0398\u03b5\u03c3\u03c3\u03b1\u03bb\u03bf\u03bd\u03af\u03ba\u03b7",
      titleAccent: "\u039c\u03b5 \u03c4\u03bf\u03bd \u0394\u03b9\u03ba\u03cc \u03c3\u03b1\u03c2 \u03a4\u03c1\u03cc\u03c0\u03bf",
      subtitle: "\u0395\u03bd\u03bf\u03b9\u03ba\u03af\u03b1\u03c3\u03b7 \u03b1\u03c5\u03c4\u03bf\u03ba\u03b9\u03bd\u03ae\u03c4\u03c9\u03bd \u03c3\u03c4\u03b7\u03bd \u03ba\u03b1\u03c1\u03b4\u03b9\u03ac \u03c4\u03b7\u03c2 \u0392\u03cc\u03c1\u03b5\u03b9\u03b1\u03c2 \u0395\u03bb\u03bb\u03ac\u03b4\u03b1\u03c2. \u0391\u03c0\u03cc \u03bf\u03b9\u03ba\u03bf\u03bd\u03bf\u03bc\u03b9\u03ba\u03ac \u03bc\u03ad\u03c7\u03c1\u03b9 \u03c0\u03bf\u03bb\u03c5\u03c4\u03b5\u03bb\u03ae SUV.",
      cta: "\u0394\u03b5\u03af\u03c4\u03b5 \u03c4\u03bf\u03bd \u03a3\u03c4\u03cc\u03bb\u03bf",
      ctaSecondary: "\u0396\u03b7\u03c4\u03ae\u03c3\u03c4\u03b5 \u03a0\u03c1\u03bf\u03c3\u03c6\u03bf\u03c1\u03ac",
    },
    booking: {
      pickupDate: "\u0397\u03bc/\u03bd\u03af\u03b1 \u03a0\u03b1\u03c1\u03b1\u03bb\u03b1\u03b2\u03ae\u03c2",
      returnDate: "\u0397\u03bc/\u03bd\u03af\u03b1 \u0395\u03c0\u03b9\u03c3\u03c4\u03c1\u03bf\u03c6\u03ae\u03c2",
      pickupLocation: "\u03a4\u03bf\u03c0\u03bf\u03b8\u03b5\u03c3\u03af\u03b1 \u03a0\u03b1\u03c1\u03b1\u03bb\u03b1\u03b2\u03ae\u03c2",
      category: "\u03a4\u03cd\u03c0\u03bf\u03c2 \u039f\u03c7\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2",
      search: "\u0391\u03bd\u03b1\u03b6\u03ae\u03c4\u03b7\u03c3\u03b7 \u0394\u03b9\u03b1\u03b8\u03ad\u03c3\u03b9\u03bc\u03c9\u03bd",
      office: "\u0393\u03c1\u03b1\u03c6\u03b5\u03af\u03bf - \u03a0\u03c5\u03bb\u03b1\u03af\u03b1",
      airport: "\u0391\u03b5\u03c1\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03bf \u0398\u03b5\u03c3/\u03bd\u03af\u03ba\u03b7\u03c2 (SKG)",
      hotel: "\u03a0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03c3\u03b5 \u039e\u03b5\u03bd\u03bf\u03b4\u03bf\u03c7\u03b5\u03af\u03bf",
      allTypes: "\u038c\u03bb\u03bf\u03b9 \u03bf\u03b9 \u03a4\u03cd\u03c0\u03bf\u03b9",
    },
    fleet: {
      title: "\u039f \u03a3\u03c4\u03cc\u03bb\u03bf\u03c2 \u03bc\u03b1\u03c2",
      subtitle: "\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03c0\u03bf\u03b9\u03ba\u03b9\u03bb\u03af\u03b1 \u03c4\u03c9\u03bd \u03ba\u03b1\u03bb\u03ac \u03c3\u03c5\u03bd\u03c4\u03b7\u03c1\u03b7\u03bc\u03ad\u03bd\u03c9\u03bd \u03bf\u03c7\u03b7\u03bc\u03ac\u03c4\u03c9\u03bd \u03bc\u03b1\u03c2",
      perDay: "/\u03b7\u03bc\u03ad\u03c1\u03b1",
      viewDetails: "\u039b\u03b5\u03c0\u03c4\u03bf\u03bc\u03ad\u03c1\u03b5\u03b9\u03b5\u03c2",
      bookThis: "\u039a\u03c1\u03ac\u03c4\u03b7\u03c3\u03b7",
      filters: "\u03a6\u03af\u03bb\u03c4\u03c1\u03b1",
      category: "\u039a\u03b1\u03c4\u03b7\u03b3\u03bf\u03c1\u03af\u03b1",
      fuel: "\u039a\u03b1\u03cd\u03c3\u03b9\u03bc\u03bf",
      transmission: "\u039a\u03b9\u03b2\u03ce\u03c4\u03b9\u03bf",
      all: "\u038c\u03bb\u03b1",
      economy: "\u039f\u03b9\u03ba\u03bf\u03bd\u03bf\u03bc\u03b9\u03ba\u03ac",
      compact: "Compact",
      suv: "SUV",
      family: "\u039f\u03b9\u03ba\u03bf\u03b3\u03b5\u03bd\u03b5\u03b9\u03b1\u03ba\u03ac",
      premium: "Premium",
      luxury: "Luxury",
      gasoline: "\u0392\u03b5\u03bd\u03b6\u03af\u03bd\u03b7",
      diesel: "\u03a0\u03b5\u03c4\u03c1\u03ad\u03bb\u03b1\u03b9\u03bf",
      hybrid: "\u03a5\u03b2\u03c1\u03b9\u03b4\u03b9\u03ba\u03cc",
      lpg: "LPG",
      manual: "\u03a7\u03b5\u03b9\u03c1\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03bf",
      automatic: "\u0391\u03c5\u03c4\u03cc\u03bc\u03b1\u03c4\u03bf",
      seats: "\u03b8\u03ad\u03c3\u03b5\u03b9\u03c2",
      hp: "hp",
      year: "\u0388\u03c4\u03bf\u03c2",
      mileage: "\u03a7\u03b9\u03bb\u03b9\u03cc\u03bc\u03b5\u03c4\u03c1\u03b1",
      engine: "\u039a\u03b9\u03bd\u03b7\u03c4\u03ae\u03c1\u03b1\u03c2",
      features: "\u03a7\u03b1\u03c1\u03b1\u03ba\u03c4\u03b7\u03c1\u03b9\u03c3\u03c4\u03b9\u03ba\u03ac",
      noCars: "\u0394\u03b5\u03bd \u03b2\u03c1\u03ad\u03b8\u03b7\u03ba\u03b1\u03bd \u03bf\u03c7\u03ae\u03bc\u03b1\u03c4\u03b1",
    },
    about: {
      title: "\u03a3\u03c7\u03b5\u03c4\u03b9\u03ba\u03ac \u03bc\u03b5 \u03c4\u03b7\u03bd Euro Cars",
      subtitle: "\u039f \u03ad\u03bc\u03c0\u03b9\u03c3\u03c4\u03bf\u03c2 \u03c3\u03c5\u03bd\u03b5\u03c1\u03b3\u03ac\u03c4\u03b7\u03c2 \u03c3\u03b1\u03c2 \u03c3\u03c4\u03b7 \u0398\u03b5\u03c3\u03c3\u03b1\u03bb\u03bf\u03bd\u03af\u03ba\u03b7 \u03b1\u03c0\u03cc \u03c4\u03bf 2020",
      story: "\u0397 Euro Cars \u03b9\u03b4\u03c1\u03cd\u03b8\u03b7\u03ba\u03b5 \u03bc\u03b5 \u03ad\u03bd\u03b1\u03bd \u03b1\u03c0\u03bb\u03cc \u03c3\u03ba\u03bf\u03c0\u03cc: \u03bd\u03b1 \u03c0\u03b1\u03c1\u03ad\u03c7\u03b5\u03b9 \u03b1\u03be\u03b9\u03cc\u03c0\u03b9\u03c3\u03c4\u03b5\u03c2, \u03c0\u03c1\u03bf\u03c3\u03b9\u03c4\u03ad\u03c2 \u03ba\u03b1\u03b9 \u03c0\u03bf\u03b9\u03bf\u03c4\u03b9\u03ba\u03ad\u03c2 \u03c5\u03c0\u03b7\u03c1\u03b5\u03c3\u03af\u03b5\u03c2 \u03b5\u03bd\u03bf\u03b9\u03ba\u03af\u03b1\u03c3\u03b7\u03c2 \u03b1\u03c5\u03c4\u03bf\u03ba\u03b9\u03bd\u03ae\u03c4\u03c9\u03bd \u03c3\u03c4\u03b7 \u0398\u03b5\u03c3\u03c3\u03b1\u03bb\u03bf\u03bd\u03af\u03ba\u03b7 \u03ba\u03b1\u03b9 \u03c4\u03b7 \u0392\u03cc\u03c1\u03b5\u03b9\u03b1 \u0395\u03bb\u03bb\u03ac\u03b4\u03b1.",
      mission: "\u0397 \u0391\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae \u03bc\u03b1\u03c2",
      missionText: "\u039d\u03b1 \u03c0\u03c1\u03bf\u03c3\u03c6\u03ad\u03c1\u03bf\u03c5\u03bc\u03b5 \u03bc\u03b9\u03b1 \u03b5\u03be\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03ae \u03b5\u03bc\u03c0\u03b5\u03b9\u03c1\u03af\u03b1 \u03b5\u03bd\u03bf\u03b9\u03ba\u03af\u03b1\u03c3\u03b7\u03c2 \u03bc\u03b5 \u03b4\u03b9\u03b1\u03c6\u03b1\u03bd\u03ae \u03c4\u03b9\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7, \u03ac\u03c8\u03bf\u03b3\u03b1 \u03c3\u03c5\u03bd\u03c4\u03b7\u03c1\u03b7\u03bc\u03ad\u03bd\u03b1 \u03bf\u03c7\u03ae\u03bc\u03b1\u03c4\u03b1 \u03ba\u03b1\u03b9 \u03c0\u03c1\u03bf\u03c3\u03c9\u03c0\u03bf\u03c0\u03bf\u03b9\u03b7\u03bc\u03ad\u03bd\u03b7 \u03b5\u03be\u03c5\u03c0\u03b7\u03c1\u03ad\u03c4\u03b7\u03c3\u03b7.",
      whyUs: "\u0393\u03b9\u03b1\u03c4\u03af \u0395\u03bc\u03ac\u03c2",
      reasons: [
        "\u039c\u03b5\u03b3\u03ac\u03bb\u03b7 \u03c0\u03bf\u03b9\u03ba\u03b9\u03bb\u03af\u03b1 \u03ba\u03b1\u03bb\u03ac \u03c3\u03c5\u03bd\u03c4\u03b7\u03c1\u03b7\u03bc\u03ad\u03bd\u03c9\u03bd \u03bf\u03c7\u03b7\u03bc\u03ac\u03c4\u03c9\u03bd",
        "\u0391\u03bd\u03c4\u03b1\u03b3\u03c9\u03bd\u03b9\u03c3\u03c4\u03b9\u03ba\u03ad\u03c2 \u03c4\u03b9\u03bc\u03ad\u03c2 \u03b1\u03c0\u03cc \u20ac20/\u03b7\u03bc\u03ad\u03c1\u03b1",
        "\u0394\u03c9\u03c1\u03b5\u03ac\u03bd \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03c3\u03c4\u03bf \u03b1\u03b5\u03c1\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03bf",
        "24/7 \u03bf\u03b4\u03b9\u03ba\u03ae \u03b2\u03bf\u03ae\u03b8\u03b5\u03b9\u03b1",
        "\u0395\u03c5\u03ad\u03bb\u03b9\u03ba\u03c4\u03b7 \u03c0\u03b1\u03c1\u03b1\u03bb\u03b1\u03b2\u03ae & \u03b5\u03c0\u03b9\u03c3\u03c4\u03c1\u03bf\u03c6\u03ae",
        "\u039a\u03b1\u03bd\u03ad\u03bd\u03b1 \u03ba\u03c1\u03c5\u03c6\u03cc \u03ba\u03cc\u03c3\u03c4\u03bf\u03c2",
      ],
    },
    contact: {
      title: "\u0395\u03c0\u03b9\u03ba\u03bf\u03b9\u03bd\u03c9\u03bd\u03af\u03b1",
      subtitle: "\u0395\u03af\u03bc\u03b1\u03c3\u03c4\u03b5 \u03b5\u03b4\u03ce \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03c3\u03b1\u03c2 \u03b2\u03bf\u03b7\u03b8\u03ae\u03c3\u03bf\u03c5\u03bc\u03b5",
      form: {
        name: "\u039f\u03bd\u03bf\u03bc\u03b1\u03c4\u03b5\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf",
        email: "Email",
        phone: "\u03a4\u03b7\u03bb\u03ad\u03c6\u03c9\u03bd\u03bf",
        subject: "\u0398\u03ad\u03bc\u03b1",
        message: "\u039c\u03ae\u03bd\u03c5\u03bc\u03b1",
        send: "\u0391\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae",
        success: "\u03a4\u03bf \u03bc\u03ae\u03bd\u03c5\u03bc\u03b1 \u03c3\u03c4\u03ac\u03bb\u03b8\u03b7\u03ba\u03b5 \u03b5\u03c0\u03b9\u03c4\u03c5\u03c7\u03ce\u03c2!",
      },
      info: {
        address: "Τομπάζη 49, Πυλαία 555 35",
        phone: "+30 690 908 6661",
        email: "info@eurocars-rent.gr",
        hours: "\u0394\u03b5\u03c5-\u03a0\u03b1\u03c1: 09:00-21:00 | \u03a3\u03ac\u03b2-\u039a\u03c5\u03c1: 09:00-19:00",
      },
    },
    services: {
      title: "\u039f\u03b9 \u03a5\u03c0\u03b7\u03c1\u03b5\u03c3\u03af\u03b5\u03c2 \u03bc\u03b1\u03c2",
      subtitle: "\u038c,\u03c4\u03b9 \u03c7\u03c1\u03b5\u03b9\u03ac\u03b6\u03b5\u03c3\u03c4\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03bf \u03c4\u03ad\u03bb\u03b5\u03b9\u03bf \u03c4\u03b1\u03be\u03af\u03b4\u03b9",
      items: [
        { title: "Airport Transfer", desc: "\u0394\u03c9\u03c1\u03b5\u03ac\u03bd \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 & \u03c0\u03b1\u03c1\u03b1\u03bb\u03b1\u03b2\u03ae \u03c3\u03c4\u03bf \u03b1\u03b5\u03c1\u03bf\u03b4\u03c1\u03cc\u03bc\u03b9\u03bf (SKG)" },
        { title: "\u03a0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7 \u03c3\u03b5 \u039e\u03b5\u03bd\u03bf\u03b4\u03bf\u03c7\u03b5\u03af\u03bf", desc: "\u03a6\u03ad\u03c1\u03bd\u03bf\u03c5\u03bc\u03b5 \u03c4\u03bf \u03b1\u03c5\u03c4\u03bf\u03ba\u03af\u03bd\u03b7\u03c4\u03bf \u03c3\u03c4\u03bf \u03be\u03b5\u03bd\u03bf\u03b4\u03bf\u03c7\u03b5\u03af\u03bf \u03c3\u03b1\u03c2" },
        { title: "24/7 \u03a5\u03c0\u03bf\u03c3\u03c4\u03ae\u03c1\u03b9\u03be\u03b7", desc: "\u039f\u03b4\u03b9\u03ba\u03ae \u03b2\u03bf\u03ae\u03b8\u03b5\u03b9\u03b1 \u03ba\u03b1\u03b9 \u03b5\u03be\u03c5\u03c0\u03b7\u03c1\u03ad\u03c4\u03b7\u03c3\u03b7 \u03cc\u03bb\u03bf \u03c4\u03bf 24\u03c9\u03c1\u03bf" },
        { title: "\u03a0\u03bb\u03ae\u03c1\u03b7\u03c2 \u0391\u03c3\u03c6\u03ac\u03bb\u03b9\u03c3\u03b7", desc: "\u03a0\u03bb\u03ae\u03c1\u03b7\u03c2 \u03ba\u03ac\u03bb\u03c5\u03c8\u03b7 \u03b3\u03b9\u03b1 \u03b1\u03bd\u03ad\u03bc\u03b5\u03bb\u03b7 \u03bf\u03b4\u03ae\u03b3\u03b7\u03c3\u03b7" },
      ],
    },
    bookingForm: {
      title: "\u039f\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u039a\u03c1\u03ac\u03c4\u03b7\u03c3\u03b7",
      name: "\u039f\u03bd\u03bf\u03bc\u03b1\u03c4\u03b5\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf",
      email: "Email",
      phone: "\u03a4\u03b7\u03bb\u03ad\u03c6\u03c9\u03bd\u03bf",
      pickupDate: "\u0397\u03bc/\u03bd\u03af\u03b1 \u03a0\u03b1\u03c1\u03b1\u03bb\u03b1\u03b2\u03ae\u03c2",
      returnDate: "\u0397\u03bc/\u03bd\u03af\u03b1 \u0395\u03c0\u03b9\u03c3\u03c4\u03c1\u03bf\u03c6\u03ae\u03c2",
      pickupLocation: "\u03a4\u03bf\u03c0\u03bf\u03b8\u03b5\u03c3\u03af\u03b1",
      notes: "\u0395\u03b9\u03b4\u03b9\u03ba\u03ac \u0391\u03b9\u03c4\u03ae\u03bc\u03b1\u03c4\u03b1",
      submit: "\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u039a\u03c1\u03ac\u03c4\u03b7\u03c3\u03b7\u03c2",
      success: "\u0397 \u03ba\u03c1\u03ac\u03c4\u03b7\u03c3\u03b7 \u03c5\u03c0\u03bf\u03b2\u03bb\u03ae\u03b8\u03b7\u03ba\u03b5! \u0398\u03b1 \u03b5\u03c0\u03b9\u03ba\u03bf\u03b9\u03bd\u03c9\u03bd\u03ae\u03c3\u03bf\u03c5\u03bc\u03b5 \u03c3\u03cd\u03bd\u03c4\u03bf\u03bc\u03b1.",
      total: "\u0395\u03ba\u03c4\u03b9\u03bc\u03ce\u03bc\u03b5\u03bd\u03bf \u03a3\u03cd\u03bd\u03bf\u03bb\u03bf",
      days: "\u03b7\u03bc\u03ad\u03c1\u03b5\u03c2",
    },
    footer: {
      tagline: "\u0395\u03bd\u03bf\u03b9\u03ba\u03af\u03b1\u03c3\u03b7 \u03b1\u03c5\u03c4\u03bf\u03ba\u03b9\u03bd\u03ae\u03c4\u03c9\u03bd \u03c3\u03c4\u03b7 \u0398\u03b5\u03c3\u03c3\u03b1\u03bb\u03bf\u03bd\u03af\u03ba\u03b7",
      quickLinks: "\u0393\u03c1\u03ae\u03b3\u03bf\u03c1\u03bf\u03b9 \u03a3\u03cd\u03bd\u03b4\u03b5\u03c3\u03bc\u03bf\u03b9",
      contactInfo: "\u0395\u03c0\u03b9\u03ba\u03bf\u03b9\u03bd\u03c9\u03bd\u03af\u03b1",
      hours: "\u038f\u03c1\u03b5\u03c2 \u039b\u03b5\u03b9\u03c4\u03bf\u03c5\u03c1\u03b3\u03af\u03b1\u03c2",
      rights: "\u039c\u03b5 \u03b5\u03c0\u03b9\u03c6\u03cd\u03bb\u03b1\u03be\u03b7 \u03c0\u03b1\u03bd\u03c4\u03cc\u03c2 \u03b4\u03b9\u03ba\u03b1\u03b9\u03ce\u03bc\u03b1\u03c4\u03bf\u03c2.",
      monFri: "\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1 - \u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae: 09:00 - 21:00",
      satSun: "\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf - \u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae: 09:00 - 19:00",
    },
    common: {
      from: "\u03b1\u03c0\u03cc",
      km: "km",
      cc: "cc",
    },
  },
};
